// extracted by mini-css-extract-plugin
module.exports = {"anchor":"style_anchor__2JeIQ","title":"style_title__20bo7"};